<template>
  <div class="d-flex align-center">
    <SysInputFormatadorValor
      v-model="produto.qtde_pedido"
      ref="inputRef"
      :max-digitos="configuracoes.CASAS_DECIMAIS_CARRINHO"
      remover-valor-irrelevante
      centralizar
      class="input-regular font-resp"
      @keydown.enter="verificarQuantidadeCompraValidaComDaley()"
      @focus="$event.target.select()"
      @blur="verificarQuantidadeCompraValidaComDaley()"
      @click.stop
    />

    <ValidaLoteMinimo
      v-if="!LOTE_MINIMO_VALIDO"
      ref="loteMinimoRef"
      v-model.number="produto.qtde_pedido"
      :lote-minimo="produto.lote_minimo"
      @change="nao_validar_venda_futura = false;verificarQuantidadeCompraValidaComDaley()"
      @forcar-sugestao="editarQuantidadeCompra()"
    />

    <AlertaEstoqueEstetico
      v-else-if="!ESTOQUE_ESTETICO_VALIDO"
      ref="alertaEstoqueEsteticoRef"
      v-model.number="produto.qtde_pedido"
      :estoque_minimo="produto.estoque_minimo"
      :lote_minimo="produto.lote_minimo"
      :estoque="produto.estoque"
      :estoque_transito="produto.estoque_transito"
      @change="editarQuantidadeCompra()"
      @forcar-sugestao="editarQuantidadeCompra()"
    />

    <ValidacaoSugestaoVendaFutura
      v-else-if="!QUANTIDADE_VENDA_FUTURA_VALIDA"
      ref="alertaVendaFuturaRef"
      :quantidade_compra="Number(produto.qtde_pedido)"
      :quantidade_sugestao="Number(produto.sugerido)"
      :quantidade_venda_futura="Number(produto.estoque_pendente)"
      @aplicar-valor="valor => {
        nao_validar_venda_futura = true;
        produto.qtde_pedido = valor;
        verificarQuantidadeCompraValidaComDaley();
      }"
    />
  </div>
</template>

<script>
import SysInputFormatadorValor from "@/components/utils/InputFormatadorDeValor.vue";
import AlertaEstoqueEstetico from "@/components/compra/SugestaoEstoqueEstetico.vue";
import ValidaLoteMinimo from '@/components/compra/ValidaLoteMinimo.vue';
import {mapGetters} from "vuex";
import {verificarMultiploLoteMinimo} from "@/components/compra/CompraDistribuidaPorFilial/DistribuirCompraPorFilial/VerificaMuliploLoteMinimo";
import {atualizarProdutoNoCarrinho} from "@/api/compraPorProdutosGerais/Carrinho";
import {logout} from "@/helpers";
import ValidacaoSugestaoVendaFutura from "@/components/compra/ProdutosGerais/ValidacaoSugestao/VendaFutura/Index.vue";
import {validarVendaFutura} from "@/components/compra/ProdutosGerais/ValidacaoSugestao/VendaFutura/utils";

export default {
  name: "QuantidadeProduto",
  props: {
    produto: Object,
    pedido_selecionado: Object
  },
  components: {
    ValidacaoSugestaoVendaFutura,
    SysInputFormatadorValor,
    AlertaEstoqueEstetico,
    ValidaLoteMinimo
  },
  data: () => ({
    edicao_salva: true,
    nao_validar_venda_futura: false,
  }),
  computed: {
    ...mapGetters({
      configuracoes: "configuracoes/carrinho",
    }),
    LOTE_MINIMO_VALIDO() {
      return verificarMultiploLoteMinimo(this.produto.qtde_pedido, this.produto.lote_minimo);
    },
    ESTOQUE_ESTETICO_VALIDO() {
      const qtd_compra = Number(this.produto.qtde_pedido).toFixed(4);
      const estoque_minimo = Number(this.produto.estoque_minimo).toFixed(4);
      const estoque = Number(this.produto.estoque).toFixed(4);
      const estoque_transito = Number(this.produto.estoque_transito).toFixed(4);
      return (Number(qtd_compra) + Number(estoque) + Number(estoque_transito)) >= Number(estoque_minimo);
    },
    QUANTIDADE_VENDA_FUTURA_VALIDA() {
      return validarVendaFutura({
        quantidade_compra: Number(this.produto.qtde_pedido),
        quantidade_sugestao: Number(this.produto.sugerido),
        quantidade_venda_futura: Number(this.produto.estoque_pendente)
      });
    },
  },
  watch: {
    'produto.qtde_pedido': function () {
      this.edicao_salva = false;
    }
  },
  methods: {
    verificarQuantidadeCompraValidaComDaley(daley = 100) {
      setTimeout(this.verificarQuantidadeCompraValida, daley);
    },
    verificarQuantidadeCompraValida() {
      if (this.produto.qtde_pedido <= 0) {
        return;
      }

      if (!this.LOTE_MINIMO_VALIDO) {
        this.$refs.loteMinimoRef.ativador_menu = true;
        return;
      }

      if (!this.ESTOQUE_ESTETICO_VALIDO) {
        this.$refs.alertaEstoqueEsteticoRef.ativador_menu = true;
        return;
      }

      if (!this.QUANTIDADE_VENDA_FUTURA_VALIDA && !this.nao_validar_venda_futura) {
        this.$refs.alertaVendaFuturaRef.menu_ativo = true;
        return;
      }

      if (this.edicao_salva) {
        return;
      }

      this.editarQuantidadeCompra();
    },
    editarQuantidadeCompra() {
      const parametros = {
        idpedido: this.pedido_selecionado.idpedido,
        idproduto: this.produto.idproduto,
        qtde_pedido: this.getQtdePedidoEmbalagemMinimo()
      };

      this.$store.dispatch('loading/addRequisicao',
        atualizarProdutoNoCarrinho(parametros)
          .then(() => {
            this.edicao_salva = true;
            this.produto.exportado = 'N';
          })
          .catch(logout)
      );
    },
    getQtdePedidoEmbalagemMinimo() {
      if (this.pedido_selecionado.emb_master === "N") {
        return parseFloat(this.produto.qtde_pedido);
      }

      if (this.produto.tipo_fator_conversao === 'D') {
        return parseFloat(this.produto.qtde_pedido) * parseFloat(this.produto.multiplo_compra);
      }

      return parseFloat(this.produto.qtde_pedido) / parseFloat(this.produto.multiplo_compra);
    },
    focus() {
      this.$refs.inputRef.focus()
    }
  }
}
</script>

<style scoped>

</style>
